(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sculptique-product-mobile-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProductSection = (root) => {
      if (!root || root.dataset.sqProductReady === 'true') return;
      root.dataset.sqProductReady = 'true';

      const gallery = root.querySelector('[data-sq-gallery]');
      const slides = Array.from(root.querySelectorAll('[data-sq-slide]'));
      const thumbs = Array.from(root.querySelectorAll('[data-sq-thumb]'));
      const detailItems = Array.from(root.querySelectorAll('.sq-product__details details'));

      detailItems.forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          detailItems.forEach((otherDetail) => {
            if (otherDetail !== detail) otherDetail.open = false;
          });
        });
      });

      const setActiveThumb = (index) => {
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        const activeThumb = thumbs[index];
        const thumbStrip = activeThumb?.parentElement;
        if (activeThumb && thumbStrip && thumbStrip.scrollWidth > thumbStrip.clientWidth) {
          const targetLeft = activeThumb.offsetLeft - ((thumbStrip.clientWidth - activeThumb.offsetWidth) / 2);
          thumbStrip.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
        }
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.sqThumb);
          const slide = slides[index];
          if (!slide || !gallery) return;
          gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          setActiveThumb(index);
        });
      });

      let galleryFrame;
      if (gallery) {
        gallery.addEventListener('scroll', () => {
          window.cancelAnimationFrame(galleryFrame);
          galleryFrame = window.requestAnimationFrame(() => {
            if (window.innerWidth > 749) return;
            const activeIndex = slides.reduce((closest, slide, index) => {
              const distance = Math.abs(slide.offsetLeft - gallery.scrollLeft - gallery.offsetLeft);
              return distance < closest.distance ? { index, distance } : closest;
            }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
            setActiveThumb(activeIndex);
          });
        }, { passive: true });
      }

      root.querySelectorAll('[data-sq-quantity]').forEach((quantity) => {
        const input = quantity.querySelector('input[name="quantity"]');
        const minus = quantity.querySelector('[data-sq-quantity-minus]');
        const plus = quantity.querySelector('[data-sq-quantity-plus]');
        if (!input) return;
        if (minus) minus.addEventListener('click', () => {
          input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        if (plus) plus.addEventListener('click', () => {
          input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    };

    const initAllProductSections = (scope = document) => {
      scope.querySelectorAll('[data-sq-product]').forEach(initProductSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllProductSections());
    } else {
      initAllProductSections();
    }

    document.addEventListener('shopify:section:load', (event) => initAllProductSections(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sculptique-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProductSection = (root) => {
      if (!root || root.dataset.sqProductReady === 'true') return;
      root.dataset.sqProductReady = 'true';

      const gallery = root.querySelector('[data-sq-gallery]');
      const slides = Array.from(root.querySelectorAll('[data-sq-slide]'));
      const thumbs = Array.from(root.querySelectorAll('[data-sq-thumb]'));
      const deliveryDateElement = root.querySelector('[data-sq-delivery-date]');
      const kachingBundle = root.querySelector('[data-sq-kaching-slot] kaching-bundle');
      const currentPriceElement = root.querySelector('[data-sq-current-price]');
      const comparePriceElement = root.querySelector('[data-sq-compare-price]');
      const detailItems = Array.from(root.querySelectorAll('.sq-product__details details'));

      detailItems.forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          detailItems.forEach((otherDetail) => {
            if (otherDetail !== detail) otherDetail.open = false;
          });
        });
      });

      if (deliveryDateElement) {
        const deliveryDate = new Date();
        deliveryDate.setDate(deliveryDate.getDate() + 3);
        deliveryDateElement.textContent = new Intl.DateTimeFormat('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric'
        }).format(deliveryDate);
      }

      if (kachingBundle) {
        let priceFrame;
        const syncKachingPrice = () => {
          window.cancelAnimationFrame(priceFrame);
          priceFrame = window.requestAnimationFrame(() => {
            const checked = kachingBundle.querySelector('input[type="radio"]:checked');
            const selectedBar = checked?.closest('.kaching-bundles__bar') || kachingBundle.querySelector('.kaching-bundles__bar--selected');
            if (!selectedBar) return;
            const current = selectedBar.querySelector('.kaching-bundles__bar-price')?.textContent?.trim();
            const compare = selectedBar.querySelector('.kaching-bundles__bar-full-price')?.textContent?.trim();
            if (current && currentPriceElement) currentPriceElement.textContent = current;
            if (comparePriceElement) {
              comparePriceElement.hidden = !compare;
              if (compare) comparePriceElement.textContent = compare;
            }
          });
        };
        kachingBundle.addEventListener('change', syncKachingPrice);
        kachingBundle.addEventListener('click', () => window.setTimeout(syncKachingPrice, 0));
        new MutationObserver(syncKachingPrice).observe(kachingBundle, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'checked']
        });
        syncKachingPrice();
      }

      const setActiveThumb = (index) => {
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        const activeThumb = thumbs[index];
        const thumbStrip = activeThumb?.parentElement;
        if (activeThumb && thumbStrip && thumbStrip.scrollWidth > thumbStrip.clientWidth) {
          const targetLeft = activeThumb.offsetLeft - ((thumbStrip.clientWidth - activeThumb.offsetWidth) / 2);
          thumbStrip.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
        }
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.sqThumb);
          const slide = slides[index];
          if (!slide || !gallery) return;
          gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          setActiveThumb(index);
        });
      });

      let galleryFrame;
      if (gallery) {
        gallery.addEventListener('scroll', () => {
          window.cancelAnimationFrame(galleryFrame);
          galleryFrame = window.requestAnimationFrame(() => {
            if (window.innerWidth > 749) return;
            const activeIndex = slides.reduce((closest, slide, index) => {
              const distance = Math.abs(slide.offsetLeft - gallery.scrollLeft - gallery.offsetLeft);
              return distance < closest.distance ? { index, distance } : closest;
            }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
            setActiveThumb(activeIndex);
          });
        }, { passive: true });
      }

      root.querySelectorAll('[data-sq-quantity]').forEach((quantity) => {
        const input = quantity.querySelector('input[name="quantity"]');
        const minus = quantity.querySelector('[data-sq-quantity-minus]');
        const plus = quantity.querySelector('[data-sq-quantity-plus]');
        if (!input) return;
        if (minus) minus.addEventListener('click', () => {
          input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        if (plus) plus.addEventListener('click', () => {
          input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    };

    const initAllProductSections = (scope = document) => {
      scope.querySelectorAll('[data-sq-product]').forEach(initProductSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllProductSections());
    } else {
      initAllProductSections();
    }

    document.addEventListener('shopify:section:load', (event) => initAllProductSections(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sculptique-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initReviews = (scope = document) => {
      scope.querySelectorAll('[data-sq-reviews-section]').forEach((section) => {
        if (section.dataset.sqReviewsInitialized === 'true') return;
        section.dataset.sqReviewsInitialized = 'true';
        const cards = Array.from(section.querySelectorAll('[data-sq-review-card]'));
        const button = section.querySelector('[data-sq-review-more]');
        const initialCount = 5;
        cards.forEach((card, index) => { card.hidden = index >= initialCount; });
        if (!button || cards.length <= initialCount) {
          if (button) button.hidden = true;
          return;
        }
        button.addEventListener('click', () => {
          cards.forEach((card) => { card.hidden = false; });
          button.hidden = true;
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initReviews(), { once: true });
    else initReviews();
    document.addEventListener('shopify:section:load', (event) => initReviews(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sculptique-symptom-router"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRouter = (root) => {
      if (!root || root.dataset.sqReady === 'true') return;
      root.dataset.sqReady = 'true';

      const tabs = [...root.querySelectorAll('.sq-router__tab')];
      const controls = [...root.querySelectorAll('[data-sq-zone]')];
      const images = [...root.querySelectorAll('[data-sq-image]')];
      const panels = [...root.querySelectorAll('[data-sq-panel]')];

      const activate = (zone, moveFocus = false) => {
        controls.forEach((control) => {
          const active = control.dataset.sqZone === zone;
          control.classList.toggle('is-active', active);
          if (control.classList.contains('sq-router__tab')) {
            control.setAttribute('aria-selected', String(active));
            control.tabIndex = active ? 0 : -1;
          } else {
            control.setAttribute('aria-pressed', String(active));
          }
        });
        images.forEach((image) => image.classList.toggle('is-active', image.dataset.sqImage === zone));
        panels.forEach((panel) => { panel.hidden = panel.dataset.sqPanel !== zone; });
        if (moveFocus) {
          const activeTab = tabs.find((tab) => tab.dataset.sqZone === zone);
          activeTab?.focus();
        }
      };

      controls.forEach((control) => control.addEventListener('click', () => activate(control.dataset.sqZone)));
      tabs.forEach((tab, index) => {
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(tabs[next].dataset.sqZone, true);
        });
      });

      const cta = root.querySelector('.sq-router__cta');
      cta?.addEventListener('click', (event) => {
        const target = document.querySelector(cta.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });

      activate('belly');
    };

    document.querySelectorAll('[data-sq-router]').forEach(initRouter);
    document.addEventListener('shopify:section:load', (event) => initRouter(event.target.querySelector('[data-sq-router]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sculptique-system"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSystemSections = (scope = document) => {
      scope.querySelectorAll('[data-sq-system-section]').forEach((section) => {
        if (section.dataset.sqSystemInitialized === 'true') return;
        section.dataset.sqSystemInitialized = 'true';

        const visual = section.querySelector('[data-sq-system-visual]');
        const frames = Array.from(section.querySelectorAll('[data-sq-system-frame]'));
        if (!visual || frames.length === 0) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const showFrame = (index) => {
          frames.forEach((frame, frameIndex) => {
            frame.classList.toggle('is-active', frameIndex === index);
          });
        };

        if (reduceMotion || !('IntersectionObserver' in window)) {
          showFrame(frames.length - 1);
          return;
        }

        const reveal = () => {
          let index = 0;
          showFrame(index);

          const advance = () => {
            index += 1;
            showFrame(index);
            if (index < frames.length - 1) {
              window.setTimeout(advance, 620);
            }
          };

          window.setTimeout(advance, 320);
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            reveal();
          });
        }, { threshold: 0.22 });

        observer.observe(visual);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSystemSections(), { once: true });
    } else {
      initSystemSections();
    }

    document.addEventListener('shopify:section:load', (event) => initSystemSections(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sculptique-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const circumference = 2 * Math.PI * 48;

    const revealTimeline = (root) => {
      if (root.dataset.sqTimelineRevealed === 'true') return;
      root.dataset.sqTimelineRevealed = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const milestones = Array.from(root.querySelectorAll('[data-sq-milestone]'));
      const stats = Array.from(root.querySelectorAll('[data-sq-stat]'));

      milestones.forEach((milestone, index) => {
        window.setTimeout(() => milestone.classList.add('is-active'), reducedMotion ? 0 : index * 150);
      });

      const statsDelay = reducedMotion ? 0 : milestones.length * 150 + 130;
      window.setTimeout(() => {
        stats.forEach((stat) => {
          const target = Number(stat.dataset.target || 0);
          const number = stat.querySelector('[data-sq-number]');
          const donut = stat.querySelector('[data-sq-donut]');
          if (donut) donut.style.strokeDashoffset = String(circumference * (1 - target / 100));

          if (!number || reducedMotion) {
            if (number) number.textContent = String(target);
            return;
          }

          const duration = 1100;
          const started = performance.now();
          const tick = (now) => {
            const progress = Math.min((now - started) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            number.textContent = String(Math.round(target * eased));
            if (progress < 1) window.requestAnimationFrame(tick);
          };
          number.textContent = '0';
          window.requestAnimationFrame(tick);
        });
      }, statsDelay);
    };

    const initTimeline = (root) => {
      if (!root || root.dataset.sqTimelineReady === 'true') return;
      root.dataset.sqTimelineReady = 'true';

      if (!('IntersectionObserver' in window)) {
        revealTimeline(root);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealTimeline(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      observer.observe(root);
    };

    const initAllTimelines = (scope = document) => {
      scope.querySelectorAll('[data-sq-timeline]').forEach(initTimeline);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllTimelines());
    } else {
      initAllTimelines();
    }

    document.addEventListener('shopify:section:load', (event) => initAllTimelines(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
